import { AlertCircle } from '@gympass/yoga-icons';
import { useIntl } from 'react-intl';

import * as S from './styles';

const UpdatePhoneNumberBanner: React.FC = () => {
  const intl = useIntl();

  return (
    <S.StyledBanner
      message={intl.formatMessage({ id: 'TWOFA.BANNERMESSAGE.MOBILEUPDATED' })}
      variant="Informative"
      icon={AlertCircle}
      data-testid="updatePhoneNumberBanner"
    />
  );
};

export default UpdatePhoneNumberBanner;
